import { createStyles, Theme, makeStyles } from "@material-ui/core";

interface LynxInputStylesProps {
    size: "small" | "medium" | "large";
    error?: boolean;
}

export const lynxInputStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: "100%",
        },

        inputBase: {
            padding: ({ size }: LynxInputStylesProps) => {
                if (size === "small") {
                    return theme.spacing("5px", 2, "3px", 2);
                } else if (size === "medium") {
                    return theme.spacing("7px", 2, "7px", 2);
                } else {
                    return theme.spacing("11px", 2, "10px", 2);
                }
            },
            borderRadius: theme.shape.borderRadius,
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: theme.colors.neutrals.neutral300,
        },

        input: {
            padding: 0,
            ...theme.typography.body1,
            height: "initial",

            "&::placeholder": {
                color: theme.colors.neutrals.neutral300,
                opacity: 1,
            },
        },

        label: {
            marginBottom: ({ size }: LynxInputStylesProps) =>
                size === "small" ? "5px" : "3px",
            fontSize: ({ size }: LynxInputStylesProps) =>
                size === "small"
                    ? theme.typography.subtitle2.fontSize
                    : theme.typography.body2.fontSize,
            lineHeight: ({ size }: LynxInputStylesProps) =>
                size === "small"
                    ? theme.typography.subtitle2.lineHeight
                    : theme.typography.body2.lineHeight,
            color: theme.colors.neutrals.neutral500,

            "&.Mui-focused": {
                color: theme.colors.neutrals.neutral500,
            },
        },

        focused: {
            borderColor: ` ${theme.colors.primary.blue400} !important`,
        },

        error: {
            borderColor: theme.colors.feedback.error,
        },

        disabled: {
            backgroundColor: theme.colors.neutrals.neutral200,
            borderColor: theme.colors.neutrals.neutral200,
            color: theme.colors.neutrals.neutral400,
        },

        assistiveText: {
            marginTop: "6px",
            color: ({ error }: LynxInputStylesProps) =>
                error
                    ? theme.colors.feedback.error
                    : theme.colors.neutrals.neutral400,
        },
    })
);
